import {Col, Row} from "reactstrap";
import PropTypes from "prop-types";
import React from "react";

const TableHeader = (props) => {

  const {headers} = props;
  return (
    <div className="header p-3 mb-1">
      <Row className="d-flex">
        { headers ? headers.map((header, index) => (
          <Col md={header.width} lg={header.width} key={index} className="align-items-center justify-content-center d-flex">
            {header.name}
          </Col>
        )) : <></>}
      </Row>
    </div>
  )
}

TableHeader.propTypes = {
  headers: PropTypes.any,
}

export default TableHeader;
